import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';

interface SessionExpiredErrorDialogProps {
  onClose: (openState: false) => void;
}

/**
 * This one is slightly diferent than the other axios error dialog because it has a reload button
 * @param onClose
 * @constructor
 */
export function SessionExpiredErrorDialog({
  onClose,
}: SessionExpiredErrorDialogProps) {
  return (
    <DialogConfirmation
      id="session-expired"
      open={true}
      title={translate('Your Session Expired Due to Inactivity')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton
          key="ok"
          appearance="primary"
          onClick={() => location.reload()}
        >
          {translate('Reload')}
        </UIButton>,
      ]}
    >
      {translate('Your edits are saved, but the page needs to reload.')}
    </DialogConfirmation>
  );
}
